// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"54546fe8","36":"7aa8bad4","105":"8de93aa1","548":"5a068522","734":"ce6a9f97","740":"a87ce949","965":"91ba4890","966":"e7e2093b"}[chunkId] + ".chunk.js";
};